import React from 'react';
import { Link, useLocation } from 'react-router-dom';

const Header: React.FC = () => {
    const location = useLocation();
    const isLoginPage = location.pathname === '/login';
    const isRegisterPage = location.pathname === '/register';

    return (
        <header className="fixed top-0 left-0 right-0 z-50 bg-white/95 backdrop-blur-sm border-b border-william-200">
            <div className="max-w-[1200px] mx-auto px-4 sm:px-6 lg:px-4">
                <div className="flex items-center justify-between py-4">
                    <a
                        href="https://basiqr.com"
                        className="flex items-center gap-2 shrink-0 rounded-md focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-william-600 focus-visible:ring-offset-2"
                    >
                        <img src="/BasiQR-icon.svg" alt="" aria-hidden="true" className="h-8 w-auto" />
                        <div className="flex flex-col items-start">
                            <span className="font-outfit font-bold text-william-800 text-lg leading-none">
                                BasiQR
                            </span>
                            <span className="text-[9px] font-semibold bg-william-600 text-white px-1.5 py-0.5 rounded-full leading-none mt-0.5">
                                BETA
                            </span>
                        </div>
                    </a>

                    <div className="flex items-center gap-2">
                        {!isLoginPage && (
                            <Link
                                to="/login"
                                className="rounded-xl px-3 py-1.5 text-[15px] font-semibold text-william-700 hover:bg-william-100/60 transition-colors focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-william-600 focus-visible:ring-offset-2"
                            >
                                Sign in
                            </Link>
                        )}
                        {!isRegisterPage && (
                            <Link
                                to="/register"
                                className="inline-flex items-center justify-center px-5 py-2 bg-william-600 text-white text-[15px] font-semibold rounded-2xl hover:bg-william-700 transition-colors focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-william-600 focus-visible:ring-offset-2"
                            >
                                Sign Up
                            </Link>
                        )}
                    </div>
                </div>
            </div>
        </header>
    );
};

export default Header;
